import { render, staticRenderFns } from "./GroupDates.vue?vue&type=template&id=79641855&"
import script from "./GroupDates.vue?vue&type=script&lang=js&"
export * from "./GroupDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports